import { useState } from 'react';
import type { FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ApiError } from '../lib/api';

export default function LoginPage() {
  const { login, user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: string } };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="page-loading">Cargando…</div>;
  if (user && user.role === 'admin') {
    const dest = location.state?.from && location.state.from !== '/login' ? location.state.from : '/stats';
    return <Navigate to={dest} replace />;
  }

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const me = await login(email.trim(), password);
      if (me.role !== 'admin') {
        setError('Esta cuenta no tiene permisos de administrador.');
        return;
      }
      navigate(location.state?.from || '/stats', { replace: true });
    } catch (err) {
      if (err instanceof ApiError) setError(err.message || 'Error al iniciar sesión');
      else setError('No se pudo iniciar sesión. Inténtalo de nuevo.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <h1>Panel Admin</h1>
        <span className="muted">Evangelización Digital · Huelva</span>
        {error && <div className="alert alert-error">{error}</div>}
        {user && user.role !== 'admin' && (
          <div className="alert alert-error">
            Sesión de {user.email} sin rol admin. Cierra sesión para continuar.
          </div>
        )}
        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Contraseña</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>
        <button type="submit" className="btn" disabled={submitting} style={{ width: '100%' }}>
          {submitting ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
